import _slicedToArray from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import axios from 'axios';
import levenshtein from 'fast-levenshtein';
var __defProp$5 = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = function __defNormalProp$5(obj, key, value) {
  return key in obj ? __defProp$5(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$5 = function __spreadValues$5(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols$5(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$5 = function __spreadProps$5(a, b) {
  return __defProps$5(a, __getOwnPropDescs$5(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols$5(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
function formatStepResponseData(requestData) {
  var safeRequestData = requestData || {};
  var auth = safeRequestData.auth,
    stepFromJSON = safeRequestData.step,
    metaFromJSON = safeRequestData.meta,
    _safeRequestData$capt = safeRequestData.capturedData,
    capturedData = _safeRequestData$capt === void 0 ? {} : _safeRequestData$capt;
  var formatFormMetaItem = function formatFormMetaItem() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$slug = _ref.slug,
      slug = _ref$slug === void 0 ? "" : _ref$slug,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? Number() : _ref$position,
      _ref$friendlyname = _ref.friendlyname,
      friendlyname = _ref$friendlyname === void 0 ? "" : _ref$friendlyname;
    return {
      slug: slug,
      friendlyName: friendlyname,
      position: position
    };
  };
  var formatStepData = function formatStepData(stepFromJSON2) {
    var _ref2 = stepFromJSON2 || {},
      data = _ref2.data,
      _ref2$webhookResult = _ref2.webhookResult,
      webhookResult = _ref2$webhookResult === void 0 ? {} : _ref2$webhookResult;
    var _a = data || {},
      _a$friendlyname = _a.friendlyname,
      friendlyName = _a$friendlyname === void 0 ? "" : _a$friendlyname,
      restData = __objRest(_a, ["friendlyname"]);
    return __spreadProps$5(__spreadValues$5({}, stepFromJSON2), {
      webhookResult: webhookResult,
      data: __spreadProps$5(__spreadValues$5({}, restData), {
        friendlyName: friendlyName
      })
    });
  };
  var metaSteps = (metaFromJSON == null ? void 0 : metaFromJSON.forms) || [];
  var formattedData = {
    auth: auth,
    step: formatStepData(stepFromJSON),
    meta: {
      lastStep: metaFromJSON == null ? void 0 : metaFromJSON.lastStep,
      steps: metaSteps.map(function (item) {
        return formatFormMetaItem(item);
      })
    },
    capturedData: capturedData
  };
  return formattedData;
}
function formatReqPayload(_ref3) {
  var stepSlug = _ref3.stepSlug,
    _ref3$stepFieldsPaylo = _ref3.stepFieldsPayload,
    stepFieldsPayload = _ref3$stepFieldsPaylo === void 0 ? {} : _ref3$stepFieldsPaylo,
    _ref3$metadata = _ref3.metadata,
    metadata = _ref3$metadata === void 0 ? {} : _ref3$metadata;
  var formattedFields = Object.keys(stepFieldsPayload).map(function (itemKey) {
    return {
      slug: itemKey,
      value: stepFieldsPayload[itemKey]
    };
  });
  return JSON.stringify({
    step: {
      slug: stepSlug,
      fields: formattedFields
    },
    metadata: metadata
  });
}
var __async$2 = function __async$2(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var APIService = /*#__PURE__*/function () {
  function APIService(_ref4) {
    var formAccess = _ref4.formAccess,
      debug = _ref4.debug;
    _classCallCheck(this, APIService);
    var rootEndpoint = this.formatRoot(formAccess == null ? void 0 : formAccess.root);
    this.debug = debug;
    this.formName = formAccess == null ? void 0 : formAccess.formName;
    this.endpoints = {
      root: rootEndpoint,
      base: "".concat(rootEndpoint, "/form/").concat(formAccess == null ? void 0 : formAccess.formName)
    };
  }
  return _createClass(APIService, [{
    key: "getStartForm",
    value: function getStartForm(sessionKey) {
      return __async$2(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var userHasLocalSession, headersConfig;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              userHasLocalSession = !!sessionKey;
              headersConfig = userHasLocalSession ? {
                authorization: "Bearer ".concat(sessionKey)
              } : {};
              _context.next = 4;
              return axios.get(this.endpoints.base, {
                headers: headersConfig
              }).then(function (res) {
                var _a;
                return formatStepResponseData((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.formData);
              });
            case 4:
              return _context.abrupt("return", _context.sent);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getNextStep",
    value: function getNextStep(_0, _1, _2) {
      return __async$2(this, arguments, function (sessionKey, currentStepSlug, _ref5) {
        var _this = this;
        var stepFieldsPayload = _ref5.stepFieldsPayload,
          requestsMetadata = _ref5.requestsMetadata;
        return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var endpoint, dataToSend;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = "".concat(_this.endpoints.base, "/next");
                dataToSend = formatReqPayload({
                  stepSlug: currentStepSlug,
                  stepFieldsPayload: stepFieldsPayload,
                  metadata: requestsMetadata
                });
                _context2.next = 4;
                return axios.post(endpoint, dataToSend, {
                  headers: {
                    authorization: "Bearer ".concat(sessionKey)
                  }
                }).then(function (res) {
                  var _a;
                  return formatStepResponseData((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.formData);
                });
              case 4:
                return _context2.abrupt("return", _context2.sent);
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })();
      });
    }
  }, {
    key: "getPreviousStep",
    value: function getPreviousStep(sessionKey, currentStepSlug) {
      return __async$2(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var endpoint;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              endpoint = "".concat(this.endpoints.base, "/").concat(currentStepSlug, "/previous");
              _context3.next = 3;
              return axios.get(endpoint, {
                headers: {
                  authorization: "Bearer ".concat(sessionKey)
                }
              }).then(function (res) {
                var _a;
                return formatStepResponseData((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.formData);
              });
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getDebugStep",
    value: function getDebugStep(stepSlug) {
      return __async$2(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var endpoint;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              endpoint = "".concat(this.endpoints.root, "/debug/").concat(this.formName, "/").concat(stepSlug);
              _context4.next = 3;
              return axios.get(endpoint).then(function (res) {
                var _a;
                return formatStepResponseData((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.formData);
              });
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "upload",
    value: function upload(sessionKey, file, fileName) {
      return __async$2(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var formData, endpoint, config;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              formData = new FormData();
              formData.append("file", file);
              formData.append("filename", fileName);
              endpoint = "".concat(this.endpoints.root, "/upload");
              config = {
                method: "post",
                url: endpoint,
                headers: {
                  Authorization: "Bearer ".concat(sessionKey),
                  "Content-Type": "multipart/form-data"
                },
                data: formData
              };
              _context5.next = 7;
              return axios(config);
            case 7:
              return _context5.abrupt("return", _context5.sent);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "formatRoot",
    value: function formatRoot(root) {
      var urlEndsWithSlash = root.endsWith("/");
      return urlEndsWithSlash ? root.slice(0, -1) : "".concat(root);
    }
  }]);
}();
var LOCALSTORE_KEY = "firebolt-store";
function getFireboltLocalStorage() {
  var data = localStorage.getItem(LOCALSTORE_KEY) || "{}";
  return JSON.parse(data);
}
function getFormSession(formName) {
  var _a;
  var fireboltLocalStorage = getFireboltLocalStorage();
  if (!Object.keys(fireboltLocalStorage).length) return;
  return (_a = fireboltLocalStorage == null ? void 0 : fireboltLocalStorage.sessionKeys) == null ? void 0 : _a[formName];
}
var __defProp$4 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = function __defNormalProp$4(obj, key, value) {
  return key in obj ? __defProp$4(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues$4(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4) {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropSymbols$4(b)),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var prop = _step3.value;
        if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return a;
};
var __spreadProps$4 = function __spreadProps$4(a, b) {
  return __defProps$4(a, __getOwnPropDescs$4(b));
};
function createFormSession(formName, authKey) {
  var fireboltLocalStorage = getFireboltLocalStorage();
  var sessionData = __spreadProps$4(__spreadValues$4({}, fireboltLocalStorage), {
    sessionKeys: __spreadProps$4(__spreadValues$4({}, (fireboltLocalStorage == null ? void 0 : fireboltLocalStorage.sessionKeys) || {}), _defineProperty({}, formName, authKey))
  });
  localStorage.setItem(LOCALSTORE_KEY, JSON.stringify(sessionData));
}
var __defProp$3 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = function __defNormalProp$3(obj, key, value) {
  return key in obj ? __defProp$3(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues$3(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3) {
    var _iterator4 = _createForOfIteratorHelper(__getOwnPropSymbols$3(b)),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var prop = _step4.value;
        if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  return a;
};
var __spreadProps$3 = function __spreadProps$3(a, b) {
  return __defProps$3(a, __getOwnPropDescs$3(b));
};
function clearAllFormSessions() {
  localStorage == null ? void 0 : localStorage.removeItem(LOCALSTORE_KEY);
}
function clearFormSession(formName) {
  var fireboltLocalStorage = getFireboltLocalStorage();
  var sessions = (fireboltLocalStorage == null ? void 0 : fireboltLocalStorage.sessionKeys) || {};
  var filteredSessionsKeys = Object.keys(sessions).filter(function (key) {
    return key !== formName;
  }).reduce(function (acc, itemKey) {
    return __spreadProps$3(__spreadValues$3({}, acc), _defineProperty({}, itemKey, sessions[itemKey]));
  }, {});
  localStorage.setItem(LOCALSTORE_KEY, JSON.stringify(__spreadProps$3(__spreadValues$3({}, fireboltLocalStorage), {
    sessionKeys: filteredSessionsKeys
  })));
}
function getAutofillParam() {
  var _a;
  var params = new URLSearchParams((_a = window == null ? void 0 : window.location) == null ? void 0 : _a.search);
  var autoFillString = params == null ? void 0 : params.get("autofill");
  if (autoFillString) {
    autoFillString = window.atob(autoFillString);
    if (decodeURI(autoFillString) !== decodeURIComponent(autoFillString)) {
      autoFillString = decodeURIComponent(autoFillString);
    }
    return JSON.parse(autoFillString.replace(/'/g, '"'));
  }
}
function getUrlParams() {
  var query = location.search.substring(1);
  return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split("&").reduce(function (params, param) {
    var _param$split = param.split("="),
      _param$split2 = _slicedToArray(_param$split, 2),
      key = _param$split2[0],
      value = _param$split2[1];
    params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
    return params;
  }, {}) : {};
}
var UIPropsPresets = {};
var __defProp$2 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp$2(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues$2(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2) {
    var _iterator5 = _createForOfIteratorHelper(__getOwnPropSymbols$2(b)),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var prop = _step5.value;
        if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
  return a;
};
var __spreadProps$2 = function __spreadProps$2(a, b) {
  return __defProps$2(a, __getOwnPropDescs$2(b));
};
function applyAutofill(stepData, autoFillData) {
  var _a, _b, _c;
  if (!!autoFillData) {
    var fieldsFromAPI = (_b = (_a = stepData == null ? void 0 : stepData.step) == null ? void 0 : _a.data) == null ? void 0 : _b.fields;
    var mappedFields = fieldsFromAPI.map(function (field) {
      var _a2, _b2;
      var fieldSlug = field == null ? void 0 : field.slug;
      var fieldPresetName = field == null ? void 0 : field["ui:props-preset"];
      var fieldPreset = UIPropsPresets[fieldPresetName] || {};
      var fullFieldValue = __spreadProps$2(__spreadValues$2({}, field), {
        "ui:props": __spreadValues$2(__spreadValues$2({}, field == null ? void 0 : field["ui:props"]), fieldPreset)
      });
      (_a2 = fullFieldValue == null ? void 0 : fullFieldValue["ui:props"]) == null ? void 0 : _a2.mask;
      var autofillValue = (_b2 = autoFillData == null ? void 0 : autoFillData[fieldSlug]) == null ? void 0 : _b2.value;
      return __spreadValues$2(__spreadValues$2({}, field), autofillValue ? {
        value: autofillValue
      } : {});
    });
    return __spreadProps$2(__spreadValues$2({}, stepData), {
      step: __spreadProps$2(__spreadValues$2({}, stepData == null ? void 0 : stepData.step), {
        data: __spreadProps$2(__spreadValues$2({}, (_c = stepData == null ? void 0 : stepData.step) == null ? void 0 : _c.data), {
          fields: mappedFields
        })
      })
    });
  } else return stepData;
}
var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp$1(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues$1(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    var _iterator6 = _createForOfIteratorHelper(__getOwnPropSymbols$1(b)),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var prop = _step6.value;
        if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps$1(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
function applyStepPropsPresets(stepData, addons) {
  var _a, _b, _c;
  var fieldsFromAPI = (_b = (_a = stepData == null ? void 0 : stepData.step) == null ? void 0 : _a.data) == null ? void 0 : _b.fields;
  var mappedFields = mappedFieldsFromAPI(fieldsFromAPI, addons == null ? void 0 : addons.uiPropsPresets);
  return __spreadProps$1(__spreadValues$1({}, stepData), {
    step: __spreadProps$1(__spreadValues$1({}, stepData == null ? void 0 : stepData.step), {
      data: __spreadProps$1(__spreadValues$1({}, (_c = stepData == null ? void 0 : stepData.step) == null ? void 0 : _c.data), {
        fields: mappedFields
      })
    })
  });
}
function mappedFieldsFromAPI() {
  var fieldsFromAPI = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var propsPresetsCollections = arguments.length > 1 ? arguments[1] : undefined;
  var _getFormattedPropsPre = getFormattedPropsPresets(propsPresetsCollections),
    collectionsMap = _getFormattedPropsPre.collectionsMap,
    allPresetsMap = _getFormattedPropsPre.allPresetsMap;
  var mappedFields = fieldsFromAPI.map(function (field) {
    return __spreadProps$1(__spreadValues$1({}, field), {
      "ui:props": getFieldProps(field, collectionsMap, allPresetsMap)
    });
  });
  return mappedFields;
}
function getFieldProps(field, collectionsMap, allPresetsMap) {
  var _a;
  var fieldPresetName = (field == null ? void 0 : field["ui:props-preset"]) || "";
  var _ref6 = fieldPresetName == null ? void 0 : fieldPresetName.split(":"),
    _ref7 = _slicedToArray(_ref6, 2),
    collectionPreset = _ref7[0],
    specificCollection = _ref7[1];
  var useSpecificCollection = !!specificCollection;
  var fieldProps = field == null ? void 0 : field["ui:props"];
  if (useSpecificCollection) {
    var collection = collectionsMap == null ? void 0 : collectionsMap[specificCollection];
    if (!collection) {
      throw new Error("Collection does not exists");
    }
    var hasPreset = !!(collection == null ? void 0 : collection[collectionPreset]);
    if (!hasPreset) {
      throw new Error("Collection ".concat(specificCollection, " doesn't have preset ").concat(collectionPreset));
    }
  }
  var fieldPresetProps = useSpecificCollection ? (_a = collectionsMap == null ? void 0 : collectionsMap[specificCollection]) == null ? void 0 : _a[collectionPreset] : allPresetsMap[fieldPresetName] || {};
  var fullfieldWithPropsPreset = __spreadValues$1(__spreadValues$1({}, fieldPresetProps), fieldProps);
  return fullfieldWithPropsPreset;
}
function getFormattedPropsPresets(propsPresetsCollections) {
  var safePropsPresetsCollections = propsPresetsCollections || [];
  var collectionsMap = getCollectionsMap(safePropsPresetsCollections);
  var allCustomPresetsMap = getCustomPresetsMap(collectionsMap);
  return {
    propsPresetsCollections: safePropsPresetsCollections,
    collectionsMap: collectionsMap,
    allCustomPresetsMap: allCustomPresetsMap,
    allPresetsMap: __spreadValues$1(__spreadValues$1({}, UIPropsPresets), allCustomPresetsMap)
  };
}
function getCollectionsMap(propsPresetsCollections) {
  return propsPresetsCollections.reduce(function (acc, _ref8) {
    var name = _ref8.name,
      presets = _ref8.presets;
    return __spreadProps$1(__spreadValues$1({}, acc), _defineProperty({}, name, presets));
  }, {});
}
function getCustomPresetsMap(collectionsMap) {
  var presetsMap = Object.keys(collectionsMap).reduce(function (acc, collectionName) {
    var collection = collectionsMap[collectionName];
    return __spreadValues$1(__spreadValues$1({}, acc), collection);
  }, {});
  return presetsMap;
}
function formatFormOutput(formData) {
  var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    autofillData = _ref9.autofillData,
    addons = _ref9.addons;
  var withPropsPresets = applyStepPropsPresets(formData, addons);
  return autofillData ? applyAutofill(withPropsPresets, autofillData) : withPropsPresets;
}
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator7 = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var prop = _step7.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __async$1 = function __async$1(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var FireboltFormEngine = /*#__PURE__*/function () {
  function FireboltFormEngine(formAccess) {
    var _ref0 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref0$requestsMetadat = _ref0.requestsMetadata,
      requestsMetadata = _ref0$requestsMetadat === void 0 ? {} : _ref0$requestsMetadat,
      _ref0$debug = _ref0.debug,
      debug = _ref0$debug === void 0 ? false : _ref0$debug,
      _ref0$addons = _ref0.addons,
      addons = _ref0$addons === void 0 ? {} : _ref0$addons,
      mockStep = _ref0.mockStep,
      _ref0$enforceNewSessi = _ref0.enforceNewSession,
      enforceNewSession = _ref0$enforceNewSessi === void 0 ? false : _ref0$enforceNewSessi;
    _classCallCheck(this, FireboltFormEngine);
    this.enforceNewSession = false;
    this.requestsMetadata = requestsMetadata;
    this.formName = formAccess == null ? void 0 : formAccess.formName;
    this.debug = debug;
    this.addons = addons;
    this.APIService = new APIService({
      formAccess: formAccess,
      debug: debug
    });
    this.mockStep = mockStep;
    this.enforceNewSession = enforceNewSession;
  }
  return _createClass(FireboltFormEngine, [{
    key: "decideStepResponse",
    value: function decideStepResponse(requestResponse) {
      if (!!this.debug && !!this.mockStep) {
        var safeResponse = requestResponse || {};
        var safeStep = safeResponse.step || {};
        return __spreadProps(__spreadValues({}, safeResponse), {
          step: __spreadProps(__spreadValues({}, safeStep), {
            data: this.mockStep
          })
        });
      }
      return requestResponse;
    }
  }, {
    key: "start",
    value: function start() {
      return __async$1(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;
        var autofillData, urlParams, sessionId, formSessionKey, firstStepData, usedStepData, formattedData;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              autofillData = getAutofillParam();
              urlParams = getUrlParams();
              if (autofillData) {
                this.clearSession();
              }
              sessionId = urlParams == null ? void 0 : urlParams.session_id;
              formSessionKey = function () {
                if (_this2.enforceNewSession) return "";else if (sessionId) return sessionId;else return getFormSession(_this2.formName);
              }();
              if (formSessionKey) {
                createFormSession(this.formName, formSessionKey);
              }
              _context6.next = 8;
              return this.APIService.getStartForm(formSessionKey);
            case 8:
              firstStepData = _context6.sent;
              usedStepData = this.decideStepResponse(firstStepData);
              formattedData = formatFormOutput(usedStepData, {
                autofillData: autofillData,
                addons: this.addons
              });
              if (!formSessionKey) {
                createFormSession(this.formName, formattedData == null ? void 0 : formattedData.auth);
              }
              return _context6.abrupt("return", formattedData);
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "nextStep",
    value: function nextStep(_0, _1) {
      return __async$1(this, arguments, function (currentStepSlug, stepFieldsPayload) {
        var _this3 = this;
        var _ref1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref1$extraRequestsMe = _ref1.extraRequestsMetaData,
          extraRequestsMetaData = _ref1$extraRequestsMe === void 0 ? {} : _ref1$extraRequestsMe;
        return /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          var autofillData, formSessionKey, nextStepData, usedStepData;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                autofillData = getAutofillParam();
                formSessionKey = getFormSession(_this3.formName);
                _context7.next = 4;
                return _this3.APIService.getNextStep(formSessionKey, currentStepSlug, {
                  stepFieldsPayload: stepFieldsPayload,
                  requestsMetadata: __spreadValues(__spreadValues({}, _this3.requestsMetadata), extraRequestsMetaData)
                });
              case 4:
                nextStepData = _context7.sent;
                usedStepData = _this3.decideStepResponse(nextStepData);
                return _context7.abrupt("return", formatFormOutput(usedStepData, {
                  addons: _this3.addons,
                  autofillData: autofillData
                }));
              case 7:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        })();
      });
    }
  }, {
    key: "previousStep",
    value: function previousStep(currentStepSlug) {
      return __async$1(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var formSessionKey, previousData, usedStepData;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              formSessionKey = getFormSession(this.formName);
              _context8.next = 3;
              return this.APIService.getPreviousStep(formSessionKey, currentStepSlug);
            case 3:
              previousData = _context8.sent;
              usedStepData = this.decideStepResponse(previousData);
              return _context8.abrupt("return", formatFormOutput(usedStepData, {
                addons: this.addons
              }));
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file, fileName) {
      var formSessionKey = getFormSession(this.formName);
      return this.APIService.upload(formSessionKey, file, fileName);
    }
  }, {
    key: "debugStep",
    value: function debugStep(stepSlug) {
      return __async$1(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var autofillData, stepToDebugData;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (this.debug) {
                _context9.next = 4;
                break;
              }
              throw new Error("debug step function only works with debug arg === true,");
            case 4:
              autofillData = getAutofillParam();
              _context9.next = 7;
              return this.APIService.getDebugStep(stepSlug);
            case 7:
              stepToDebugData = _context9.sent;
              return _context9.abrupt("return", formatFormOutput(stepToDebugData, {
                autofillData: autofillData
              }));
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "addRequestMetadataItem",
    value: function addRequestMetadataItem(key, data) {
      var currentReqMetadata = this.requestsMetadata;
      this.modifyRequestMetadata(__spreadProps(__spreadValues({}, currentReqMetadata), _defineProperty({}, key, data)));
    }
  }, {
    key: "removeRequestMetadataItem",
    value: function removeRequestMetadataItem(key) {
      var currentReqMetadata = this.requestsMetadata;
      var currentReqMetaKeys = Object.keys(currentReqMetadata);
      var newMetadata = currentReqMetaKeys.filter(function (metaKey) {
        return metaKey !== key;
      }).map(function (itemKey) {
        return currentReqMetaKeys[itemKey];
      });
      this.modifyRequestMetadata(newMetadata);
    }
  }, {
    key: "modifyRequestMetadata",
    value: function modifyRequestMetadata(newPayload) {
      this.requestsMetadata = newPayload;
    }
  }, {
    key: "clearSession",
    value: function clearSession() {
      clearFormSession(this.formName);
    }
  }]);
}();
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function uploadFiles(_0, _1) {
  return __async(this, arguments, function (endpoint, _ref10) {
    var files = _ref10.files,
      slug = _ref10.slug;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
      var _a, _b, isEndpointValid, filesContructor, isFileList, isFilesValid, formData;
      return _regeneratorRuntime.wrap(function _callee0$(_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            isEndpointValid = typeof endpoint === "string" && !!endpoint;
            filesContructor = (_b = (_a = Object.getPrototypeOf(files)) == null ? void 0 : _a.constructor) == null ? void 0 : _b.name;
            isFileList = filesContructor === "FileList";
            isFilesValid = isFileList || Array.isArray(files);
            if (isEndpointValid) {
              _context0.next = 6;
              break;
            }
            throw new TypeError("Invalid endpoint ".concat(endpoint));
          case 6:
            if (isFilesValid) {
              _context0.next = 8;
              break;
            }
            throw new TypeError("invalid files passed to Firebolt upload files");
          case 8:
            if (isFilesValid) {
              _context0.next = 10;
              break;
            }
            throw new Error("invlid files");
          case 10:
            formData = new FormData();
            Array.from(files).forEach(function (file) {
              return formData.append(slug, file);
            });
            return _context0.abrupt("return", axios.post(endpoint, formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }));
          case 13:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    })();
  });
}
var FbFile = /*#__PURE__*/_createClass(function FbFile(_ref11) {
  var storageReference = _ref11.storageReference,
    _ref11$extension = _ref11.extension,
    extension = _ref11$extension === void 0 ? String() : _ref11$extension,
    _ref11$size = _ref11.size,
    size = _ref11$size === void 0 ? String() || Number() : _ref11$size,
    _ref11$name = _ref11.name,
    name = _ref11$name === void 0 ? String() : _ref11$name;
  _classCallCheck(this, FbFile);
  this.storageReference = storageReference;
  this.extension = extension;
  this.size = Number(size);
  this.name = name;
});
var autoSuggestedDomains = ["gmail.com", "hotmail.com", "outlook.com", "live.com", "icloud.com", "yahoo.com.br", "yahoo.com", "bol.com.br", "uol.com.br", "terra.com.br", "aol.com"];
function handleEmailAutoSuggestion(_ref12) {
  var value = _ref12.value,
    domainValue = _ref12.domainValue;
  if (value && domainValue !== void 0 && domainValue === "") return autoSuggestedDomains.reduce(function (acc, domain) {
    return acc.concat("".concat(value, "@").concat(domain));
  }, []);
  if (!domainValue || autoSuggestedDomains.includes(domainValue)) return [];
  return autoSuggestedDomains.reduce(function (acc, domain) {
    var distanceString = levenshtein.get(domain, domainValue);
    var isSimilar = distanceString <= 5 || domain.includes(domainValue);
    if (isSimilar || domainValue === "") return acc.concat("".concat(value, "@").concat(domain));
    return acc;
  }, []);
}
var createFireboltForm = function createFireboltForm(access, options) {
  return new FireboltFormEngine(access, options);
};
export { FbFile as File, clearAllFormSessions, clearFormSession, createFireboltForm, getAutofillParam, getFieldProps, getFormattedPropsPresets, getUrlParams, handleEmailAutoSuggestion, uploadFiles as uploadFilesToBucket };